module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-12.6b8389e5.png";